/*
 * vrtPSSTS.ts
 */
import type { RouteRecordRaw } from 'vue-router';
//
const vrtPSSTS: RouteRecordRaw = {
  path: '/powersteer/sts',
  name: 'vrtPSSTS',
  component: () => import('src/layouts/vcleSystem.vue'),
  children: [
    // {
    //   path: 'create',
    //   name: 'vrtPOWERsteerCreate',
    //   component: () => import('./vpgPOWERsteerCreate.vue'),
    // },
    // {
    //   path: 'read',
    //   name: 'vrtPOWERsteerRead',
    //   component: () => import('./vpgPOWERsteerRead.vue'),
    // },
  ],
};

export default vrtPSSTS;
